import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import {NavLink, useNavigate} from "react-router";
import { RoutersInfo } from "root";
import { Tooltip } from "@mui/material";
import Popper from "@mui/material/Popper";
import { Svg } from "assets";
import { UserInfo } from "./userInfo";

export const LeftBar = ({ toggleMenu, openingMenu }) => {
  const [isScrollable, setIsScrollable] = useState(false);
  const [isBottom, setIsBottom] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [currentItem, setCurrentItem] = useState(null);
  const [isExpanded, setIsExpanded] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const mainRef = useRef(null);
  const timeoutRef = useRef(null);
  const routingItems = RoutersInfo();
  const { pathname } = location;

  useEffect(() => {
    const checkScroll = () => {
      const container = mainRef.current;
      if (container) {
        const hasScroll = container.scrollHeight > container.clientHeight;
        setIsScrollable(hasScroll);
        setIsBottom(
          container.scrollTop + container.clientHeight >=
            container.scrollHeight - 10,
        );
      }
    };

    const handleScroll = () => checkScroll();

    const container = mainRef.current;
    if (container) {
      container.addEventListener("scroll", handleScroll);
      checkScroll();
    }

    return () => container?.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const activeItem = routingItems.find((item) =>
      item?.pathsList?.includes(pathname),
    );
    if (activeItem && !currentItem) {
      setCurrentItem(activeItem);
      if (openingMenu) {
        setIsExpanded(true);
      }
    }
  }, [pathname]);

  const handleMouseEnter = (event, item) => {
    if (item?.list?.length && !openingMenu) {
      clearTimeout(timeoutRef.current);
      setCurrentItem(item);
      setAnchorEl(event.currentTarget);
    }
  };

  const handleMouseLeave = (item) => {
    if (item?.list?.length && !openingMenu) {
      timeoutRef.current = setTimeout(() => {
        setCurrentItem(null);
      }, 200);
    }
  };

  const goToPage = (item) => {
    if (!item?.list?.length) {
      navigate(`${item?.path}`);
      setIsExpanded(false);
      setCurrentItem(null);
    } else {
      setCurrentItem((prev) => (prev?.name === item?.name ? null : item));
      setIsExpanded((prev) =>
        openingMenu && item?.name === currentItem?.name ? !prev : !!openingMenu,
      );
    }
  };

  const scroll = () => {
    const container = mainRef.current;
    if (container) {
      container.scrollTo({
        top: isBottom ? 0 : container.scrollHeight,
        behavior: "smooth",
      });
    }
  };

  return (
    <div
      className={`left-bar-new-wrapper ${!openingMenu ? "left-bar-new-wrapper-closed" : ""}`}
    >
      <div className="left-bar-new-box">
        <div style={{ height: "calc(100% - 56px)" }}>
          <div
            className="left-bar-new-header"
            style={{
              maxWidth: openingMenu ? 1000 : 72,
              overflow: "hidden",
            }}
          >
            <div className="left-bar-new-logo">
              <Svg.LogoWithoutText />
            </div>

            <p className="left-bar-new-title">Care Tech</p>
          </div>

          <div className="left-bar-new-main" ref={mainRef}>
            <div className="left-bar-new-items-wrapper">
              {routingItems
                ?.filter((item) => item)
                ?.map((item, index) => (
                  <NavLink
                    key={index}
                    to={item.path}
                    onMouseEnter={(e) => handleMouseEnter(e, item)}
                    onMouseLeave={() => handleMouseLeave(item)}
                    className={`left-bar-new-single_item-wrapper
                                            ${
                                              currentItem?.name ===
                                                item?.name && isExpanded
                                                ? "left-bar-new-single_item-wrapper-hovered"
                                                : ""
                                            }
                                            ${
                                              item?.subList?.some((path) =>
                                                pathname.startsWith(path),
                                              ) ||
                                              pathname.startsWith(
                                                item?.detail,
                                              ) ||
                                              item?.path === pathname
                                                ? "left-bar-new-single_item-wrapper-selected"
                                                : ""
                                            }`}
                  >
                    <div
                      className="left-bar-new-single_item-box"
                      onClick={() => goToPage(item)}
                      style={{
                        maxWidth: openingMenu ? 1000 : 0,
                        transition: "all .2s",
                      }}
                    >
                      <div className="left-bar-new-single_item-icon_title">
                        {item?.Icon && (
                          <div className="left-bar-new-single_item-icon">
                            <item.Icon alt="item icon" />
                          </div>
                        )}

                        {item?.name && (
                          <p className="left-bar-new-single_item-title">
                            {item?.name}
                          </p>
                        )}

                        {!!item?.activeCount && openingMenu && (
                          <div className="eft-bar-new-single_item-lis-active-count">
                            {item?.activeCount}
                          </div>
                        )}
                      </div>

                      {!!item?.list?.length && openingMenu && (
                        <div
                          className="left-bar-new-single_item-arrow-up"
                          style={{
                            transform:
                              isExpanded && currentItem?.name === item?.name
                                ? "rotate(45deg)"
                                : "rotate(-45deg)",
                          }}
                        >
                          <Svg.ArrowRightSvg />
                        </div>
                      )}
                    </div>
                    <div
                      className={`left-bar-new-single_item-list-wrapper ${
                        !!item?.list?.length &&
                        currentItem?.name === item?.name &&
                        isExpanded
                          ? "left-bar-new-single_item-list-wrapper-active"
                          : ""
                      }`}
                    >
                      {item?.list
                        ?.filter((item) => item)
                        ?.map((item, index) => (
                          <button
                            key={index}
                            className={`left-bar-new-single_item-list-box 
                        ${
                          pathname?.startsWith(item?.path) ||
                          pathname?.startsWith(item?.create) ||
                          pathname?.startsWith(item?.detail)
                            ? "left-bar-new-single_item-list-box-active"
                            : ""
                        }`}
                            onClick={(e) => {
                              e.stopPropagation();
                              goToPage(item, true);
                            }}
                          >
                            {item?.name}

                            {!!item?.activeCount && (
                              <div className="eft-bar-new-single_item-lis-active-count">
                                {item?.activeCount}
                              </div>
                            )}
                          </button>
                        ))}
                    </div>

                    {item?.name === currentItem?.name && !openingMenu && (
                      <Popper
                        open={Boolean(anchorEl)}
                        anchorEl={anchorEl}
                        placement="right"
                        className="left-menu-popper-wrapper"
                        modifiers={{
                          offset: {
                            enabled: true,
                            offset: "0,10",
                          },
                          preventOverflow: {
                            enabled: true,
                            boundariesElement: "viewport",
                          },
                        }}
                      >
                        <div
                          className={`left-bar-new-single_item-list-wrapper 
                                                             ${
                                                               !!item?.list
                                                                 ?.length &&
                                                               currentItem?.name ===
                                                                 item?.name
                                                                 ? "left-bar-new-single_item-list-wrapper-active"
                                                                 : ""
                                                             }`}
                          onMouseEnter={() => clearTimeout(timeoutRef.current)}
                          onMouseLeave={() => handleMouseLeave(item)}
                        >
                          <div className="left-bar-new-single_item-list-arrow" />
                          <p className="left-menu-popper-title">{item?.name}</p>
                          <div style={{ position: "relative", zIndex: "22" }}>
                            {item?.list
                              ?.filter((item) => item)
                              ?.map((item, index) => (
                                <button
                                  key={index}
                                  className={`left-bar-new-single_item-list-box 
                              ${
                                pathname?.startsWith(item?.path) ||
                                pathname?.startsWith(item?.create) ||
                                pathname?.startsWith(item?.detail) ||
                                currentItem?.name === item?.name
                                  ? "left-bar-new-single_item-list-box-active"
                                  : ""
                              }`}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    goToPage(item);
                                    setAnchorEl(null);
                                  }}
                                >
                                  {item?.name}

                                  {!!item?.activeCount && (
                                    <div className="eft-bar-new-single_item-lis-active-count">
                                      {item?.activeCount}
                                    </div>
                                  )}
                                </button>
                              ))}
                          </div>
                        </div>
                      </Popper>
                    )}
                  </NavLink>
                ))}
            </div>
          </div>
        </div>

        <UserInfo openingMenu={openingMenu} />

        {isScrollable && isBottom ? (
          <button onClick={scroll} className="go-to-bottom-btn">
            <Svg.ArrowRightSvg
              style={{
                transform: !isBottom ? "rotate(45deg)" : "rotate(-45deg)",
              }}
            />
          </button>
        ) : openingMenu ? (
          <div
            className="left-bar-new-footer"
            onClick={() => {
              setIsExpanded(!openingMenu ? !!currentItem : false);
              setAnchorEl(null);
              toggleMenu();
            }}
            style={{
              justifyContent: !openingMenu ? "center" : "",
            }}
          >
            <Svg.ArrowCollapseSvg
              style={{
                transform: openingMenu ? "rotate(180deg)" : "",
              }}
            />
            {openingMenu && (
              <p className="left-bar-new-opening-text">Collapse</p>
            )}
          </div>
        ) : (
          <Tooltip
            title="Expand the Navigation"
            placement="right"
            arrow
            classes={{
              popper: "expend-navigation-tooltip",
            }}
          >
            <div
              className="left-bar-new-footer"
              onClick={() => {
                setIsExpanded(!openingMenu ? !!currentItem : false);
                setAnchorEl(null);
                toggleMenu();
              }}
              style={{
                justifyContent: !openingMenu ? "center" : "",
              }}
            >
              <Svg.ArrowCollapseSvg
                style={{
                  transform: openingMenu ? "rotate(180deg)" : "",
                }}
              />

              {openingMenu && (
                <p className="left-bar-new-opening-text">Collapse</p>
              )}
            </div>
          </Tooltip>
        )}
      </div>
    </div>
  );
};
